import * as React from 'react';
import { match } from 'react-router';
import { Button } from 'reactstrap';
import './viewButtons.css';
import { ICase } from 'src/share/types/case/case';
import { ETLHelper } from 'src/share/components/ETLHelper/ETLHelper';

export interface IViewButtonsProps {
  history: any;
  caseData: ICase;
  loading: boolean;
  match: match<{ caseId: string }>
  matchesRedirect?: boolean
  permissionCase: boolean,
  isAnETLCase: boolean
};

export default class ViewButtons extends React.Component<IViewButtonsProps, any> {
  public redirectToClose = () => {
    this.props.history.push(`/close/${this.props.match.params.caseId}`)
  }
  public redirectToEdit = () => {
    this.props.history.push(`/case/edit/${this.props.match.params.caseId}`)
  }
  public redirectToCreateAlert = () => {
    this.props.history.push(`/alerts/add/${this.props.match.params.caseId}`)
  }
  public redirectToManualSearch = () => {
    this.props.history.replace('/rekognition/matches')
  }
  public render() {

    const { loading, caseData } = this.props;
    return (
      <div>
        <ETLHelper etl={this.props.caseData.etl} />
        {
          !loading && caseData.status !== "closed" && (
            <div className="buttons">
              {
                this.props.permissionCase &&
                <>
                  {
                    !this.props.isAnETLCase &&
                    <Button className="btn" onClick={this.redirectToClose}>
                      Close case
                    </Button>
                  }
                  <Button className="btn" onClick={this.redirectToEdit}>
                    Edit Case
                 </Button>
                </>
              }
              <Button className="btn btn-blue btn-secondary" onClick={this.props.matchesRedirect ? this.redirectToManualSearch : this.redirectToCreateAlert}>
                {this.props.matchesRedirect ? 'Matches search' : 'Create an Alert'}
              </Button>
            </div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/share/ViewButtons/ViewButtons.tsx